module.exports = __webpack_public_path__ + "files/2dc3dfcd3388f084e6aa42354fb95ba2.png";